// extracted by mini-css-extract-plugin
module.exports = {"tabList":"mxNzn","tabItem":"towDw","active":"G0KlK","black":"HCNlx"};